import BaseService from './BaseService';
import entities from 'src/config/entities'

class LandingPageService extends BaseService {

  constructor () {
    super({entity: entities.LANDING_PAGE})
  }
}

export default new LandingPageService()
